import DeliveryOption from '@/controllers/options/DeliveryOption';
import DeliveryOptionConstants from '@/controllers/options/DeliveryOptionConstants';
import TestController from '@/controllers/TestController';
import DeliveryOptionsProvider from '@/models/DeliveryOptionsProvider';
import Utility from '@/util/Utility';
import IOptionHandler from './IOptionHandler';

class DisplayNameHandler implements IOptionHandler {
  private readonly testController: TestController;
  constructor(testController: TestController) {
    this.testController = testController;
  }
  execute(provider: DeliveryOptionsProvider, map: Map<string, unknown>): void {
    if (map.get(DeliveryOptionConstants.STUDENT_NAME)) {
      const deliveryOption: DeliveryOption = new DeliveryOption(DeliveryOptionConstants.STUDENT_NAME);
      deliveryOption.addSetting('value', 'true');
      const displayName: string | undefined = Utility.getValueFromJWT(this.testController.jwt, 'displayName') as string;
      deliveryOption.addSetting('displayName', displayName ? displayName : '(Student Name)');
      provider.addDeliveryOption(deliveryOption);
    }
  }
}

export default DisplayNameHandler;
